import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { blueChaos, byzantium, christmasSilver, darkGray, gradient, hardCoal, lightHouse, midnightNavy, pinBall, pumpingSpice, purplishPink, roseViolet, roseVioletOpacity, star, steam, tin } from '../utils/constants';

const useColor = () => {
	const color = useSelector((state) => state.color);

	useEffect(() => {
		if (!color) return;
		document.documentElement.style.setProperty('--pin-ball', color?.pinBall || pinBall);
		document.documentElement.style.setProperty('--dark-gray', color?.darkGray || darkGray);
		document.documentElement.style.setProperty('--steam', color?.steam || steam);
		document.documentElement.style.setProperty('--tin', color?.tin || tin);
		document.documentElement.style.setProperty('--light-house', color?.lightHouse || lightHouse);
		document.documentElement.style.setProperty('--byzantium', color?.byzantium || byzantium);
		document.documentElement.style.setProperty('--rose-violet', color?.roseViolet || roseViolet);
		document.documentElement.style.setProperty('--rose-violet-opacity', color?.roseVioletOpacity || roseVioletOpacity);
		document.documentElement.style.setProperty('--star', color?.star || star);
		document.documentElement.style.setProperty('--hard-coal', color?.hardCoal || hardCoal);
		document.documentElement.style.setProperty('--christmas-silver', color?.christmasSilver || christmasSilver);
		document.documentElement.style.setProperty('--blue-chaos', color?.blueChaos || blueChaos);
		document.documentElement.style.setProperty('--gradient', color?.gradient || gradient);
		document.documentElement.style.setProperty('--pumping-spice', color?.pumpingSpice || pumpingSpice);
		document.documentElement.style.setProperty('--purplish-pink', color?.purplishPink || purplishPink);
		document.documentElement.style.setProperty('--loyalty-font-color', color?.loyaltyFontColor || midnightNavy);
		document.documentElement.style.setProperty('--loyalty-bg-color', color?.loyaltyBackgroundColor || null);
	}, [color]);
};

export default useColor;
